import { combineReducers } from 'redux'
import contact from './contact.reducer'
import contacts from './contacts.reducer'
import contactExport from './export.reducer'
import form from './form.reducer'
import fund from './fund.reducer'
import institution from './institution.reducer'
import search from './search.reducer'
import strategy from './strategy.reducer'

export default combineReducers({
  contact,
  contacts,
  contactExport,
  form,
  fund,
  institution,
  search,
  strategy
})
